const wrapper = "_35swvzddy3";
const box = "_35sb1cqejr1";
const audio = "_35sa22iboy";

export { audio, box, wrapper };
import "./input.text.style.linaria.module.css";
//# sourceMappingURL=input.text.style.js.map
